import { RESOURCE_NAME } from '@esentai/core/features/bitrixes/consts';
import { can, permission } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

import { BITRIX } from './consts/permissions';

export const canBitrix = authorizeIf(can(permission(RESOURCE_NAME, BITRIX)));
